import http from "../../http-common";
/* eslint-disable */
class ArtikelService {
  artikelList(page, itemPerPage, keyword, kategori) {
    return http.get(
      "/article/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&kategori_artikel_id=" +
        kategori,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }

  create(data, content, photo) {
    var bodyFormData = new FormData();
    bodyFormData.append("title", data.judul);
    bodyFormData.append("article_type", data.selectedKategori.id);
    bodyFormData.append("article", content);

    if (data.selectedHide && data.selectedHide != undefined) {
      bodyFormData.append("data_status", data.selectedHide.code);
    }

    if (photo != null) bodyFormData.append("photo", photo);

    return http.post("/article", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  update(data, content, photo) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("title", data.judul);
    bodyFormData.append("article_type", data.selectedKategori.id);
    bodyFormData.append("article", content);

    if (data.selectedHide && data.selectedHide != undefined) {
      bodyFormData.append("data_status", data.selectedHide.code);
    }

    if (photo != null) bodyFormData.append("photo", photo);

    return http.put(`/article/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  delete(id) {
    return http.delete(`/article/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }
}

export default new ArtikelService();
